import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import SubmitButton from '../../common/buttons/SubmitButton'
import CancelButton from '../../common/buttons/CancelButton'
import Modal from '../../common/Modal'
import MCElement from '../../common/MCElement'

import styles from './AutogenerateModal.module.scss'
import colors from '../../../assets/styles/globals.scss'
import classNames from 'classnames'

const AutogenerateModal = ({ pairedStudentsCount, onSubmit, ...props }) => {
  const { t } = useTranslation()
  const RSVP_STATUSES = {
    confirmed: t('events.common.attending'),
    declined: t('events.common.notAttending'),
    created: t('events.common.noResponse'),
    waitlisted: t('events.common.waitlisted'),
  }
  const [basedOn, setBasedOn] = useState('Age')
  const [studentsIncluded, setStudentsIncluded] = useState({})
  const [keepFilledSlots, setKeepFilledSlots] = useState(true)

  const exitModal = () => {
    props.onClose()
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={exitModal}
      className={styles.autogenerateModalContent}
    >
      <div id='AutogenerateModal'>
        <div className='animated fadeIn'>
          <div>
            <p className={styles.title}>{t('events.modal.autogenerate.title')}</p>
            <p>{t('events.modal.autogenerate.subtitle')}</p>
            <div className={styles.hl} />
            <div className='row'>
              <div className='col-12'>
                <label htmlFor='basedOn'>{t('events.modal.autogenerate.groupStudentsBy')}</label>

                <div
                  onClick={() => setBasedOn('Age')}
                  className='d-flex format-option-tee-times mb-2'
                  role='button'
                  onKeyDown={null}
                  tabIndex={0}
                >
                  <MCElement
                    type='radio'
                    onKeyDown={(e) => {
                      e.key === 'Enter' && setBasedOn('Age')
                    }}
                    primaryColor={basedOn === 'Age' ? colors.secondaryColor : colors.lightNavy}
                    isSelected={basedOn === 'Age'}
                  />
                  <span className='ml-2'>{t('events.modal.autogenerate.age')}</span>
                </div>
                <div
                  onClick={() => setBasedOn('Level')}
                  className='d-flex format-option-Shotgun'
                  role='button'
                  onKeyDown={null}
                  tabIndex={0}
                >
                  <MCElement
                    type='radio'
                    onKeyDown={(e) => {
                      e.key === 'Enter' && setBasedOn('Level')
                    }}
                    primaryColor={basedOn === 'Level' ? colors.secondaryColor : colors.lightNavy}
                    isSelected={basedOn === 'Level'}
                  />
                  <span className='ml-2'>{t('events.common.level')}</span>
                </div>
              </div>
              <div className='col-12'>
                <label htmlFor='basedOn'>{t('events.modal.autogenerate.rsvpStatus')}</label>

                {Object.keys(RSVP_STATUSES).map((rsvpStatus, index) => (
                  <div key={index} className='d-flex align-items-center mt-2'>
                    <MCElement
                      type='checkbox'
                      isSelected={studentsIncluded[rsvpStatus]}
                      clicked={() => setStudentsIncluded({ ...studentsIncluded, [rsvpStatus]: !studentsIncluded[rsvpStatus] })}
                      primaryColor={studentsIncluded[rsvpStatus] ? colors.primaryOrange : colors.lightNavy}
                      secondaryColor={colors.whiteColor}
                    />

                    <span className='ml-2 mb-2'>{RSVP_STATUSES[rsvpStatus]}</span>
                  </div>
                ))}
              </div>
              {pairedStudentsCount > 0 &&
                <div className='col-12'>
                  <label htmlFor='basedOn' className={styles.keepFilledSlotsText}>
                    {t('events.modal.autogenerate.keepFilledSlots', { count: pairedStudentsCount })}
                  </label>

                  <button
                    className={classNames('btn btn-primary', styles.responseButton, { [styles.selectedButton]: keepFilledSlots === true })}
                    onClick={() => setKeepFilledSlots(true)}
                  >
                    {t('common.yes')}
                  </button>
                  <button
                    className={classNames('btn btn-primary', styles.responseButton, { [styles.selectedButton]: keepFilledSlots === false })}
                    onClick={() => setKeepFilledSlots(false)}
                  >
                    {t('common.no')}
                  </button>
                </div>
              }
            </div>
            <div className='row py-3'>
              <div className='col-4'>
                <CancelButton
                  type='button'
                  buttonMessage={t('common.cancel')}
                  className='mt-3'
                  onClick={exitModal}
                />
              </div>
              <div className='col-7'>
                <SubmitButton
                  onClick={() => {
                    onSubmit({ basedOn, studentsIncluded, keepFilledSlots })
                    exitModal()
                  }}
                  buttonMessage={t('events.modal.autogenerate.autogenerate')}
                  buttonColor='orange-button'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

AutogenerateModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  pairedStudentsCount: PropTypes.number,
}

export default AutogenerateModal
